import {Component, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-todo-list',
  templateUrl: './todo-list.component.html',
  styles: []
})
export class TodoListComponent extends ExcTranslation implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
